export default class AppError extends Error {
  constructor(message: string) {
      const appMessage = `
      Error encountered in LazyMonkeyPagination:
      ${message}
      `;
      super(appMessage);
  }
}
